import { BrowserRouter, Route, Routes } from "react-router-dom";
import Map from "../pages/Map";
import AddPlace from "../pages/AddPlace";
import Bookmark from "../pages/Bookmark";
import Login from "../pages/Login";
import MyArea from "../pages/MyArea";
import Setting from "../pages/Setting";
import AddMyArea from "../pages/AddMyArea";
import Page404 from "../pages/Page404";
import Terms from "../pages/Terms";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Checkin from "../pages/Checkin";
import Wallet from "../pages/Wallet";
import HowTo from "../pages/HowTo";


function RoutingConfig(): JSX.Element {
    return (
        <>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Map />} />
              <Route path="/addplace" element={<AddPlace />} />
              <Route path="/bookmark" element={<Bookmark />} />
              <Route path="/login" element={<Login />} />
              <Route path="/myarea" element={<MyArea />} />
              <Route path="/setting" element={<Setting />} />
              <Route path="/addmyarea" element={<AddMyArea />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/checkin" element={<Checkin />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/howto" element={<HowTo />} />
              <Route path="*" element={<Page404 />} />
            </Routes>
          </BrowserRouter>
        </>
      );
};
export default RoutingConfig;
